(function () {
    'use strict';
    var controllerId = 'cndPCorso4AAdd';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', '_', 'datacontext', 'apl', 'aplId', 'isSuper', fn_cndPCorso4AAdd]);

    function fn_cndPCorso4AAdd($scope, $uibModalInstance, _, datacontext, apl, aplId, isSuper) {
        $scope.record = {};
        $scope.apl = apl;
        $scope.catalogoCorsi = [];
        $scope.cndPartecipazioni = [];
        $scope.isSuper = isSuper;
        $scope.record.TMisuraCode = '4A';
        $scope.record.Titolo = '';

        $scope.getPartecipazioni = function (aplId) {
            $scope.cndPartecipazioni = [];
            return datacontext.partecipazione_getAllList('', aplId, $scope.record.TMisuraCode, 0, 0, 8).then(function (data) {
                //console.info('$scope.getPartecipazioni = function (aplId) -> ', data);
                return $scope.cndPartecipazioni = data;
            });
        }

        if (aplId && aplId > 0) {
            $scope.aplId = aplId;
            $scope.record.APLId = aplId;
            $scope.getPartecipazioni($scope.aplId);
        }


        $scope.getCatCorsi = function (partecipazioneId) {
            $scope.catalogoCorsi = [];
            return datacontext.pCatalogoCorso_getAllList('', $scope.record.TMisuraCode, partecipazioneId, 0, 3).then(function (data) {
                //console.info('$scope.getCatCorsi = function (partecipazioneId) -> ', data);
                return $scope.catalogoCorsi = data;
            });
        };

        $scope.changeCatCorsi = function (catalogoCorsoId) {
            if (catalogoCorsoId > 0) {
                var catCorso = _.find($scope.catalogoCorsi, function (o) { return o.Id == catalogoCorsoId; });
                //console.info('catCorso -> ', catCorso);
                var indexMinus = (catCorso.Name).indexOf('o) - ');
                var titolo = (catCorso.Name).substring(0, indexMinus + 2);

                if ($scope.record.Titolo == null || $scope.record.Titolo.length == 0 || $scope.record.Titolo == '' || $scope.record.Titolo != titolo) {
                    $scope.record.Titolo = titolo;
                }
            } else {
                $scope.record.Titolo = '';
            }
        };


        $scope.ok = function (isValid) {
            if (isValid) {
                var result = createItem($scope.record);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            //console.info('addItem', item);
            return datacontext.pCorso_add(item).then(function (data) {
                return data;
            });
        }

        function createItem(item) {
            //console.info('createItem', item);
            return datacontext.pCorso_create(item).then(function (data) {
                return data;
            });
        }

        
    }
})();